module.exports = __webpack_public_path__ + "static/img/nian.240a3c85.png";